import client from "./client";

const W = "/warehouse";
// KPIs · مخازن · أرصدة · حركات · وصولات · وارد · صرف · مناقلات (بمنطق: مصدر يوقّع → عبور → وجهة تستلم)
export const whStats = async (branchId) =>
  (await client.get(`${W}/stats`, { params: branchId ? { branch_id: branchId } : {} })).data;
export const listWarehouses = async (branchId) =>
  (await client.get(`${W}/warehouses`, { params: branchId ? { branch_id: branchId } : {} })).data;
export const createWarehouse = async (body) => (await client.post(`${W}/warehouses`, body)).data;
export const updateWarehouse = async (id, body) =>
  (await client.patch(`${W}/warehouses/${id}`, body)).data;
export const deleteWarehouse = async (id) => (await client.delete(`${W}/warehouses/${id}`)).data;
export const listBalances = async (params) => (await client.get(`${W}/balances`, { params })).data;
export const listMovements = async (params) => (await client.get(`${W}/movements`, { params })).data;
export const listReceipts = async (branchId) =>
  (await client.get(`${W}/receipts`, { params: branchId ? { branch_id: branchId } : {} })).data;
export const listIssues = async (branchId) =>
  (await client.get(`${W}/issues`, { params: branchId ? { branch_id: branchId } : {} })).data;
export const createIssue = async (body) => (await client.post(`${W}/issues`, body)).data;
export const listTransfers = async (branchId) =>
  (await client.get(`${W}/transfers`, { params: branchId ? { branch_id: branchId } : {} })).data;
export const createTransfer = async (body) => (await client.post(`${W}/transfers`, body)).data;
export const sourceRelease = async (tid, note = "", signature = "") =>
  (await client.post(`${W}/transfers/${tid}/source-release`, { note, signature })).data;
export const destinationConfirm = async (tid, mode, note = "", adjustments = [], signature = "") =>
  (await client.post(`${W}/transfers/${tid}/destination-confirm`,
    { mode, note, adjustments, signature })).data;
export const rejectTransfer = async (tid, reason) =>
  (await client.post(`${W}/transfers/${tid}/reject`, { reason })).data;
export const getTransfer = async (tid) => (await client.get(`${W}/transfers/${tid}`)).data;

// Old incoming API kept
export const listIncoming = async (branchId) =>
  (await client.get(`${W}/incoming`, { params: branchId ? { branch_id: branchId } : {} })).data;
export const orderDetail = async (orderId) => (await client.get(`${W}/orders/${orderId}`)).data;
export const receiveOrder = async (orderId, payload) =>
  (await client.post(`${W}/orders/${orderId}/receive`, payload)).data;
